"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextAreaRequired = exports.StyledTextAreaOptional = exports.StyledTextAreaObject = exports.StyledTextAreaLabel = exports.StyledTextAreaError = exports.StyledTextAreaContainer = exports.StyledAlertIconContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledTextAreaError = _styledComponents["default"].div.withConfig({
  displayName: "TextAreastyles__StyledTextAreaError",
  componentId: "sc-5fkwye-0"
})(["", " font-size:", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["sans-serif w-100 pt1\n    ", "\n  "])), function (props) {
  return props.theme.textInput.errorColor;
}), function (props) {
  return props.theme.textInput.errorMessageFontSize || '0.875rem';
});

exports.StyledTextAreaError = StyledTextAreaError;

var StyledTextAreaContainer = _styledComponents["default"].div.withConfig({
  displayName: "TextAreastyles__StyledTextAreaContainer",
  componentId: "sc-5fkwye-1"
})(["", " border-width:", ";box-sizing:border-box;overflow:none;&.error{", " textarea{", "}}"], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 relative\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), function (props) {
  return props.floatingLabel ? 'ba' : '';
}, function (props) {
  return props.theme.textInput.borderRadius;
}, function (_ref) {
  var focus = _ref.focus,
      readOnly = _ref.readOnly,
      theme = _ref.theme;
  return focus && !readOnly ? theme.textInput.borderColorFocus : theme.textInput.borderColor;
}, function (_ref2) {
  var disabled = _ref2.disabled,
      floatingLabel = _ref2.floatingLabel,
      theme = _ref2.theme;
  return disabled && floatingLabel && "bg-".concat(theme.textInput.disabledBackground, " ").concat(theme.textInput.disabledText || theme.textInput.disabledLabel);
}), function (props) {
  return props.theme.textInput.borderWidth;
}, (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (props) {
  return "b--".concat(props.theme.textInput.errorColor);
}), (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (props) {
  return "b--".concat(props.theme.textInput.errorColor);
}));

exports.StyledTextAreaContainer = StyledTextAreaContainer;

var StyledTextAreaObject = _styledComponents["default"].textarea.withConfig({
  displayName: "TextAreastyles__StyledTextAreaObject",
  componentId: "sc-5fkwye-2"
})(["&&{", " font-size:", ";border-width:", ";box-sizing:border-box;overflow:auto;resize:none;", " ", " padding-left:0.5rem;:focus{outline:none;}}"], (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n      w-100 pl1 sans-serif\n      ", "\n      ", "\n      ", "\n    "])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.textInput.backgroundColor || 'bg-transparent';
}, function (_ref4) {
  var floatingLabel = _ref4.floatingLabel,
      theme = _ref4.theme;
  return floatingLabel ? 'bn' : "ba ".concat(theme.textInput.borderRadius);
}, function (_ref5) {
  var disabled = _ref5.disabled,
      floatingLabel = _ref5.floatingLabel,
      theme = _ref5.theme;
  return disabled && !floatingLabel && "bg-".concat(theme.textInput.disabledBackground, " ").concat(theme.textInput.disabledText || theme.textInput.disabledLabel);
}), function (_ref6) {
  var formComponents = _ref6.theme.formComponents;
  return formComponents === null || formComponents === void 0 ? void 0 : formComponents.fontSize.input;
}, function (props) {
  return props.theme.textInput.borderWidth;
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled && 'cursor: not-allowed;';
}, function (_ref8) {
  var floatingLabel = _ref8.floatingLabel,
      theme = _ref8.theme;
  return floatingLabel ? (0, _styledComponents.css)(["margin-top:1rem;padding-bottom:0.5rem;"]) : (0, _styledComponents.css)(["padding:0.625rem 0;", " :focus:not(:read-only){", "}"], (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["", ""])), theme.textInput.borderColor), (0, _ty["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["", ""])), theme.textInput.borderColorFocus));
});

exports.StyledTextAreaObject = StyledTextAreaObject;

var StyledTextAreaLabel = _styledComponents["default"].label.withConfig({
  displayName: "TextAreastyles__StyledTextAreaLabel",
  componentId: "sc-5fkwye-3"
})(["", " ", " ", " align-items:center;cursor:text;transition:all 0.15s ease;text-align:left;"], (0, _ty["default"])(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 ma0 pa0 border-box left-0 flex lh-solid\n    ", "\n    ", "\n  "])), function (_ref9) {
  var disabled = _ref9.disabled,
      theme = _ref9.theme;
  return disabled ? theme.textInput.disabledLabel : theme.textInput.label;
}, function (props) {
  return props.floatingLabel ? 'absolute' : 'mb2';
}), function (_ref10) {
  var floatingLabel = _ref10.floatingLabel,
      focusOrFilled = _ref10.focusOrFilled;
  return floatingLabel && (0, _styledComponents.css)(["text-indent:8px;pointer-events:none;top:0.5rem;", ""], focusOrFilled && "font-size: 11px; top: .25rem;");
}, function (_ref11) {
  var floatingLabel = _ref11.floatingLabel,
      formComponents = _ref11.theme.formComponents;
  return !floatingLabel && (0, _styledComponents.css)(["font-size:", ";"], formComponents === null || formComponents === void 0 ? void 0 : formComponents.fontSize.label);
});

exports.StyledTextAreaLabel = StyledTextAreaLabel;

var StyledTextAreaRequired = _styledComponents["default"].span.withConfig({
  displayName: "TextAreastyles__StyledTextAreaRequired",
  componentId: "sc-5fkwye-4"
})(["", " text-indent:0.15rem;"], (0, _ty["default"])(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "])), function (_ref12) {
  var disabled = _ref12.disabled,
      theme = _ref12.theme;
  return disabled ? theme.textInput.disabledLabel : 'red';
}));

exports.StyledTextAreaRequired = StyledTextAreaRequired;

var StyledTextAreaOptional = _styledComponents["default"].span.withConfig({
  displayName: "TextAreastyles__StyledTextAreaOptional",
  componentId: "sc-5fkwye-5"
})(["", " text-indent:0.15rem;"], (0, _ty["default"])(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["dark-gray"]))));

exports.StyledTextAreaOptional = StyledTextAreaOptional;

var StyledAlertIconContainer = _styledComponents["default"].div.withConfig({
  displayName: "TextAreastyles__StyledAlertIconContainer",
  componentId: "sc-5fkwye-6"
})(["", " width:1.5rem;top:", ";right:0.25rem;& > svg{", " width:100%;height:100%;}"], (0, _ty["default"])(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["nl1 absolute"]))), function (props) {
  return props.floatingLabel ? '0.25rem' : '1.75rem';
}, function (props) {
  return "\n      stroke: var(--".concat(props.theme.textInput.errorColor, ");\n      fill: var(--").concat(props.theme.textInput.errorColor, ");\n    ");
});

exports.StyledAlertIconContainer = StyledAlertIconContainer;